<template>
  <button type="button" class="btn-theme-circle width-xs" :class="buttonClass"  @click="handleClick">
    <i class="mdi mdi-checkbox-marked-circle font-size-16 align-middle"></i>
  </button>
</template>
<script>
export default {
  name: 'AppButtonDeleteConfirm',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      isActivated: false
    };
  },
  computed: {
    buttonClass() {
        console.log(this.disabled);
      return {
        'custom-button': true,
        'bg-success': this.disabled,
        'bg-soft-dark': !this.disabled,
        [this.className]: this.className
      };
    }
  },
  methods: {
    handleClick() {
      this.$emit('handle');
    }
  }
};
</script>